/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const ticketResource = '/admin/ticket'

const defaultPagination = 5

export default {
  getTicketTypes() {
    return OperationsRepository.get(`${ticketResource}-types`)
  },
  getAllTickets(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${ticketResource}?${filterQuery}&page=${pageNumber}&paginate=${pagination}`)
  },
  getAllTicketsNoPagination(filterQuery) {
    return Repository.get(`${ticketResource}?${filterQuery}&noPagination`)
  },
  getTicketById(id) {
    return OperationsRepository.get(`${ticketResource}/${id}`)
  },
  getTicketConvos(id) {
    return OperationsRepository.get(`${ticketResource}/${id}/convos`)
  },
  updateTicket(id, payload) {
    const formData = new FormData()
    for (const key in payload) {
      formData.append(key, payload[key])
    }
    return Repository.post(`${ticketResource}/${id}/convos`, formData)
  },
  closeTicket(id) {
    return Repository.post(`${ticketResource}/${id}/close`)
  },
  openTicket(id) {
    return Repository.post(`${ticketResource}/${id}/open`)
  },
}
